/**
 * Enum representing the possible statuses of equipment by cost center.
 */
export const EquipmentCostCenterEnum = {
  MarkedForSale: '189182',
  UnderConstruction: '189184',
} as const; //this ensures all the inner properties are readonly and cannot be changed
